import script from "./MegaMenufull.vue?vue&type=script&setup=true&lang=js"
export * from "./MegaMenufull.vue?vue&type=script&setup=true&lang=js"

import "./MegaMenufull.vue?vue&type=style&index=0&id=6588f0ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6588f0ee"]])

export default __exports__